import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/pages/HomePage/HomePage.vue'
import PaymentPage from '@/pages/PaymentPage.vue/PaymentPage.vue'
import SuccessPage from '@/pages/PaymentPage.vue/SuccessPage.vue'
import ErrorPage from '@/pages/PaymentPage.vue/ErrorPage.vue'
import { usePaymentStore } from '@/entities/Payment/model/paymentStore'
import { SentryService } from '@/shared/lib/sentry/sentryService'
import MySubscription from '@/pages/MySubscription/MySubscription.vue'
import MySubscriptions from '@/pages/MySubscriptions/MySubscriptions.vue'
import HomePage from '@/pages/HomePage/HomePage.vue'
import SetupPage from '@/pages/SetupPage/SetupPage.vue'
import PolicyPage from '@/pages/PolicyPage/PolicyPage.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
    },
    {
      path: '/payment',
      name: 'payment',
      component: PaymentPage,
    },
    {
      path: '/my-subscription',
      name: 'my-subscription',
      component: MySubscription
    },
    {
      path: '/my-subscription/:id',
      name: 'my-subscription-detail',
      component: MySubscription
    },
    {
      path: '/my-subscriptions',
      name: 'my-subscriptions',
      component: MySubscriptions
    },
    {
      path: '/success',
      name: 'success',
      component: SuccessPage
    },
    {
      path: '/error',
      name: 'error',
      component: ErrorPage
    },
    {
      path: '/setup',
      name: 'setup',
      component: SetupPage
    },
    {
      path: '/setup/:id',
      name: 'setup-detail',
      component: SetupPage
    },
    {
      path: '/policy',
      name: 'policy',
      component: PolicyPage
    },
  ],
})

// Глобальный guard для обновления данных при переходе на главную страницу
router.beforeEach((to, from, next) => {
  // Отправляем отчет о навигации в Sentry
  SentryService.trackNavigation(String(from.name || 'unknown'), String(to.name || 'unknown'), {
    from_path: from.path,
    to_path: to.path,
    from_params: from.params,
    to_params: to.params
  })
  
  // Проверяем, произошло ли обновление страницы
  // При обновлении from.name === undefined и to.name !== 'home'
  const isPageRefresh = !from.name && to.name !== 'home' && to.name !== 'policy'
  
  if (isPageRefresh) {
    console.log('🔄 Обнаружено обновление страницы, перенаправляем на главную')
    // Очищаем все временные флаги
    sessionStorage.removeItem('cameFromHome')
    sessionStorage.removeItem('purchaseType')
    sessionStorage.removeItem('isExtensionFlow')
    sessionStorage.removeItem('paymentSuccess')
    sessionStorage.removeItem('paymentError')
    sessionStorage.removeItem('refreshDataOnHome')
    
    // Перенаправляем на главную страницу
    next({ name: 'home', replace: true })
    return
  }
  
  // Останавливаем проверку статуса оплаты при любом переходе со страницы оплаты
  if (from.name === 'payment') {
    try {
      const paymentStore = usePaymentStore()
      console.log('Переход со страницы оплаты, останавливаем проверку статуса')
      paymentStore.stopPaymentStatusPolling()
    } catch (error) {
      console.warn('Ошибка при остановке проверки статуса оплаты:', error)
    }
  }
  
  // Если переходим на главную страницу с любой страницы, связанной с оплатой или страницы setup
  if (to.name === 'home' && (from.name === 'success' || from.name === 'error' || from.name === 'payment' || from.name === 'setup' || from.name === 'setup-detail')) {
    // Устанавливаем флаг для обновления данных
    sessionStorage.setItem('refreshDataOnHome', 'true')
  }
  
  next()
})

// Обработка ошибок роутера
router.onError((error) => {
  console.error('Router error:', error)
  SentryService.trackError(error, {
    error_type: 'router_error'
  }, 'Ошибка роутера')
})

export default router
